/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect, useState } from 'react'
import { Table, Spinner, Image, Badge } from 'react-bootstrap'
import { AuthContext } from '../components/ContextProvider'
import apiServices from '../services/apiServices'

function Admin() {
  const { auth } = useContext(AuthContext)
  console.log(auth)
  const [memberList, setMemberList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [filterEDMOnly, setFilterEDMOnly] = useState(false)
  const [loading, setLoading] = useState(true)

  const getMemberList = async () => {
    try {
      const res = await apiServices.data({
        path: 'member/list',
        method: 'get',
      })
      setMemberList(res)
    } catch (e) {
      console.error('❌ 取得會員清單失敗:', e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getMemberList()
  }, [])

  return (
    <div className="content p-3" style={{ minHeight: '800px' }}>
      <h3 className="mb-4">會員清單</h3>

      <div className="d-flex mb-3 gap-3">
        <input
          type="text"
          className="form-control"
          placeholder="搜尋姓名 / Email / 公司"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="filterEDM"
            checked={filterEDMOnly}
            onChange={(e) => setFilterEDMOnly(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="filterEDM">
            僅顯示訂閱者
          </label>
        </div>
      </div>
      <h3 className="mb-4">會員清單</h3>

      {loading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover responsive size="sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>姓名</th>
              <th>公司</th>
              <th>職稱</th>
              <th>產業</th>
              <th>狀態</th>
              <th>最後登入</th>
              <th>建立時間</th>
              <th>EDM</th>
              <th>會員等級</th>
              <th>頭像</th>
            </tr>
          </thead>
          <tbody>
            {memberList
              .filter((member) => {
                const keyword = searchTerm.toLowerCase()
                const match =
                  member.Name?.toLowerCase().includes(keyword) ||
                  member.Email?.toLowerCase().includes(keyword) ||
                  member.Company?.toLowerCase().includes(keyword)
                return match && (!filterEDMOnly || member.EDM)
              })
              .map((member) => (
                <tr key={member.ID}>
                  <td>{member.ID}</td>
                  <td>{member.Email}</td>
                  <td>{member.Name}</td>
                  <td>{member.Company}</td>
                  <td>{member.JobTitle}</td>
                  <td>{member.Industry}</td>
                  <td>
                    <Badge bg={member.State ? 'success' : 'secondary'}>
                      {member.State ? '啟用' : '停用'}
                    </Badge>
                  </td>
                  <td>{new Date(member.LoginTime).toLocaleString('zh-TW')}</td>
                  <td>{new Date(member.CreateTime).toLocaleString('zh-TW')}</td>
                  <td>{member.EDM ? '是' : '否'}</td>
                  <td>{Object.values(member.Plan || {}).join(', ')}</td>
                  <td>
                    <Image
                      src={member.Picture}
                      rounded
                      style={{
                        width: '50px',
                        height: '50px',
                        objectFit: 'cover',
                      }}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      )}
    </div>
  )
}

export default Admin
